<template>
    <div>
        <account-section-title
            class="d-flex align-items-center justify-content-between"
        >
            Activity
            <wallet-balance />
        </account-section-title>

        <b-list-group flush>
            <b-list-group-item
                v-if="purchasedGalleryCount"
                @click="viewPurchasedGalleries"
                button
                class="setting-item"
            >
                <div class="label">Gallery</div>
                <div class="value">
                    <font-awesome-icon icon="fa-light fa-chevron-right" />
                </div>
            </b-list-group-item>

            <b-list-group-item
                v-if="creatorRequestCount"
                to="/account/requests"
                class="setting-item"
            >
                <div class="label">Requests</div>
                <div class="value">
                    <b-badge
                        variant="primary"
                        pill
                        v-if="unseenCreatorRequestCount"
                    >
                        {{ unseenCreatorRequestCount }}
                        new
                    </b-badge>
                    <font-awesome-icon
                        v-else
                        icon="fa-light fa-chevron-right"
                    />
                </div>
            </b-list-group-item>
            <b-list-group-item
                v-if="callCount"
                to="/account/call/index"
                class="setting-item"
            >
                <div class="label">Calls</div>
                <div class="value">
                    <font-awesome-icon icon="fa-light fa-chevron-right" />
                </div>
            </b-list-group-item>
            <b-list-group-item
                v-if="creatorVideoUpvotedCount"
                to="/account/creatorVideo/upvoted"
                class="setting-item"
            >
                <div class="label">Upvoted Video</div>
                <div class="value">
                    <font-awesome-icon icon="fa-light fa-chevron-right" />
                </div>
            </b-list-group-item>
            <b-list-group-item
                v-if="mutualUserIds.length"
                to="/account/interest/mutual"
                class="setting-item"
            >
                <div class="label">
                    {{ $t("Mutual Interests") }}
                </div>
                <div class="value">
                    <font-awesome-icon icon="fa-light fa-chevron-right" />
                </div>
            </b-list-group-item>
            <b-list-group-item
                v-if="inboundUserIds.length"
                to="/account/interest/inbound"
                class="setting-item"
            >
                <div class="label">
                    {{ $t("Interests Received") }}
                </div>
                <div class="value">
                    <font-awesome-icon icon="fa-light fa-chevron-right" />
                </div>
            </b-list-group-item>
            <b-list-group-item
                v-if="outboundUserIds.length"
                to="/account/interest/outbound"
                class="setting-item"
            >
                <div class="label">
                    {{ $t("Interests Sent") }}
                </div>
                <div class="value">
                    <font-awesome-icon icon="fa-light fa-chevron-right" />
                </div>
            </b-list-group-item>
            <b-list-group-item
                v-if="viewedProfileCount"
                to="/account/userVisit/index"
                class="setting-item"
            >
                <div class="label">Viewed Profiles</div>
                <div class="value">
                    <font-awesome-icon icon="fa-light fa-chevron-right" />
                </div>
            </b-list-group-item>
            <b-list-group-item
                button
                v-if="creatorSubscriptionCount"
                class="setting-item"
                @click="$store.dispatch('setting/editSetting', 'subscriptions')"
            >
                <div class="label">Subscriptions</div>
                <div class="value">
                    <font-awesome-icon icon="fa-light fa-chevron-right" />
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
import { mapState } from "vuex";

import AccountSectionTitle from "@/components/account/AccountSectionTitle";
import WalletBalance from "@/components/utility/WalletBalance";

export default {
    created() {
        this.$store.dispatch("account/refresh");

        // interest reflection removed
        // not critical like msg, if re-enabled this can be removed
        this.$store.dispatch("interest/refresh");
    },
    computed: {
        ...mapState("interest", [
            "inboundUserIds",
            "outboundUserIds",
            "mutualUserIds",
        ]),
        ...mapState("account", [
            "creatorRequestCount",
            "unseenCreatorRequestCount",
            "purchasedGalleryCount",
            "callCount",
            "creatorVideoUpvotedCount",
            "viewedProfileCount",
            "creatorSubscriptionCount",
        ]),
        ...mapState("system", ["cordova"]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    methods: {
        viewPurchasedGalleries() {
            this.$router.push({
                name: "galleryIndex",
            });

            this.$store.dispatch("galleryIndex/setView", "purchased");
        },
    },
    components: {
        AccountSectionTitle,
        WalletBalance,
    },
};
</script>